import { render, staticRenderFns } from "./SetMng.vue?vue&type=template&id=d4b28288&scoped=true&"
import script from "./SetMng.vue?vue&type=script&lang=js&"
export * from "./SetMng.vue?vue&type=script&lang=js&"
import style0 from "./SetMng.vue?vue&type=style&index=0&id=d4b28288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b28288",
  null
  
)

export default component.exports